import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DemandWaitOverlayCoordinator {
  private readonly openRequestSubject = new Subject<number>();
  readonly openRequest$ = this.openRequestSubject.asObservable();

  requestOpen(demandId: number): void {
    if (demandId > 0) {
      this.openRequestSubject.next(demandId);
    }
  }
}
